"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const defaultTheme_1 = require("../../shared/defaultTheme");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../shared/hooks");
const IconWithLabel = ({ icon, label }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [!isMobile && (0, jsx_runtime_1.jsx)(Label, { children: label }, void 0), (0, jsx_runtime_1.jsx)(StyledFontAwesomeIcon, { icon: icon, size: "xs", color: defaultTheme_1.defaultTheme.colors.whiteBase }, void 0)] }, void 0));
};
exports.IconWithLabel = IconWithLabel;
const Wrapper = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: ${({ theme }) => theme.spacings.xxs};

  background-color: ${({ theme }) => theme.colors.greyBase};
  border-radius: ${({ theme }) => theme.spacings.xxxs};

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => `${theme.spacings.xxs} ${theme.spacings.xs}`};
  }
`;
const StyledFontAwesomeIcon = (0, styled_components_1.default)(react_fontawesome_1.FontAwesomeIcon) `
  font-size: ${({ theme }) => theme.spacings.xs};
`;
const Label = styled_components_1.default.p `
  padding-right: ${({ theme }) => theme.spacings.xxs};
  color: ${({ theme }) => theme.colors.whiteBase};
  font-size: ${({ theme }) => theme.spacings.s};
  line-height: ${({ theme }) => theme.spacings.s};
`;
//# sourceMappingURL=IconWithLabel.js.map